export const licenseIsLoading = license => license.loading;
export const isValidLicense = license => license && !license.missing && (license.status && license.status.valid);
